export default __webpack_public_path__ + "static/media/travel.dd74e942.gif";